import React from "react";
import Form from "react-bootstrap/Form";
import "./template-task-creation.scss";
import PropTypes from "prop-types";

const TemplateTaskCreationPanelFormMiddleTopNew = ({
  isSubtask,
  values,
  handleChange,
  handleBlur,
  touched,
  errors,
  setFieldValue,
}) => {
  return (
    <>
      {isSubtask && (
        <Form.Group className="template-subtask-name">
          <Form.Label>
            Subtask Name <span style={{ color: "red" }}> * </span>
          </Form.Label>
          <Form.Control
            id="subTaskName"
            name="subTaskName"
            value={values.subTaskName}
            onChange={(e) => {
              handleChange(e);
            }}
            onBlur={handleBlur}
            placeholder="Enter Subtask Name"
            isInvalid={touched.subTaskName && errors.subTaskName}
          />
          <Form.Control.Feedback type="invalid" className="inline-error">
            {errors.subTaskName}
          </Form.Control.Feedback>
        </Form.Group>
      )}

      <Form.Group className="template-task-comments">
        <Form.Label>Description</Form.Label>
        <Form.Control
          className="textarea"
          name="Description"
          value={values.Description}
          onChange={(e) => {
            handleChange(e);
          }}
          as="textarea"
          rows="3"
          placeholder="Enter Description"
        />
      </Form.Group>

      <Form.Group className="template-task-permissions">
        <Form.Check
          className="template-task-left-permission"
          type="checkbox"
          name="AllApprovers"
          checked={!values.AllApprovers}
          onChange={(e) => {
            handleChange(e);
            setFieldValue("AllApprovers", false);
          }}
          label="Any approver can approve"
          isInvalid={touched.AllApprovers && errors.AllApprovers}
        />
        <Form.Check
          className="template-task-right-permission"
          type="checkbox"
          name="AllApprovers"
          checked={values.AllApprovers}
          onChange={(e) => {
            handleChange(e);
            setFieldValue("AllApprovers", true);
          }}
          label="All approvers need to approve"
          isInvalid={touched.AllApprovers && errors.AllApprovers}
        />
        <Form.Control.Feedback type="invalid" className="inline-error">
          {errors.AllApprovers}
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
};

TemplateTaskCreationPanelFormMiddleTopNew.propTypes = {
  isSubtask: PropTypes.bool,
  values: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  touched: PropTypes.object,
  errors: PropTypes.object,
  setFieldValue: PropTypes.func,
};
export default TemplateTaskCreationPanelFormMiddleTopNew;
